import NegociaService from '@/services/negocieja.service.js'

const initialState = {
  campanhas: [], 
  politicas: [],     
  publicos: {          
    disponiveis: [],
    selecionados: []
  },
  pagamentos: {
    disponiveis: [],
    selecionados: []
  },

  loading: {
    campanhas: false,
    politicas: false,
    publicos: false,
    pagamentos: false
  }
}

export const negocieja = {
  namespaced: true,

  state: { ...initialState },

  mutations: {
    setCampanhas(state, list) {
      state.campanhas = list
    },
    setPoliticas(state, list) {
      state.politicas = list
    },
    setPublicosDisponiveis(state, list) {
      state.publicos.disponiveis = list
    },
    setPublicosSelecionados(state, list) {
      state.publicos.selecionados = list
    },
    setPagamentosDisponiveis(state, list) {
      state.pagamentos.disponiveis = list
    },
    setPagamentosSelecionados(state, list) {
      state.pagamentos.selecionados = list
    },

    setLoading(state, { key, value }) {
      if (Object.prototype.hasOwnProperty.call(state.loading, key)) {
        state.loading[key] = value
      }
    },

    resetState(state) {
      Object.assign(state, initialState)
    }
  },

  actions: {
    async fetchCampanhas({ commit }) {
      commit('setLoading', { key: 'campanhas', value: true })
      try {
        const res = await NegociaService.getCampanhas()
        commit('setCampanhas', res.data)
      } finally {
        commit('setLoading', { key: 'campanhas', value: false })
      }
    },

    async fetchPoliticas({ commit }) {
      commit('setLoading', { key: 'politicas', value: true })
      try {
        const res = await NegociaService.getPoliticas()
        const list = res.data.map(p => ({
          ...p,
          active: false,
          loadingDetails: false,
          activeTab: 'bloqueios',
          details: null
        }))
        commit('setPoliticas', list)
      } finally {
        commit('setLoading', { key: 'politicas', value: false })
      }
    },

    async fetchPublicos({ commit }, selected = []) {
      commit('setLoading', { key: 'publicos', value: true })
      try {
        const res = await NegociaService.getPublicos()
        const unique = Array.from(
          new Map(res.data.map(p => [p.idPublico, p])).values()
        )
        const idsSel = new Set(selected.map(p => p.idPublico))
        commit('setPublicosSelecionados', [...selected])
        commit(
          'setPublicosDisponiveis',
          unique.filter(p => !idsSel.has(p.idPublico))
        )
      } finally {
        commit('setLoading', { key: 'publicos', value: false })
      }
    },

    async fetchPagamentos({ commit }, selected = []) {
      commit('setLoading', { key: 'pagamentos', value: true })
      try {
        const res = await NegociaService.getPagamentos()
        const unique = Array.from(
          new Map(res.data.map(p => [p.idPagamento, p])).values()
        )
        const idsSel = new Set(selected.map(p => p.idPagamento))
        commit('setPagamentosSelecionados', [...selected])
        commit(
          'setPagamentosDisponiveis',
          unique.filter(p => !idsSel.has(p.idPagamento))
        )
      } finally {
        commit('setLoading', { key: 'pagamentos', value: false })
      }
    }
  }
}
